import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../../generic/FieldProps';
import { BirthRegistryOfficeInput } from './BirthRegistryOfficeInput';

export function BirthRegistryOfficeField<TValues extends FieldValues>({
  name,
  required = false,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <BirthRegistryOfficeInput
      value={value as string}
      onChange={onChange}
      required={required}
    />
  );
}
